import { __assign } from "tslib";
import React from "react";
import { Tabs } from "./Tabs";
import { Tab } from "./Tab";
import { MarkdownComponent } from "../..//MarkdownComponent";
var tabsCounter = 0;
var blockquoteRegex = /(^( *>).*?\n)/gm;
var orderedListRegex = /^( *[0-9])+.(.*)/gm;
export var tabsParser = function tabsParser(args) {
  return {
    replaceChildren: true,
    shouldProcessNode: function shouldProcessNode(node) {
      return node.type === "tag" && node.name === "div" && node.attribs && node.attribs.hasOwnProperty("tabs");
    },
    processNode: function processNode(node) {
      if (!node.children) {
        return null;
      }

      var children = node.children.map(function (child) {
        if (child.type === "tag" && child.name === "details" && child.children) {
          return child.children.map(function (childDetails) {
            if (childDetails.type === "tag" && childDetails.name === "summary" && childDetails.children.length === 1 && childDetails.children[0].type === "text" && childDetails.next && childDetails.next.data) {
              var label = childDetails.children[0].data;
              var source = childDetails.next.data.replace(blockquoteRegex, function (blockquote) {
                return blockquote + "\n";
              }).replace(orderedListRegex, function (listElement) {
                return "\n" + listElement + "\n";
              });
              return React.createElement(Tab, {
                key: label,
                label: label
              }, React.createElement(MarkdownComponent, __assign({
                source: source
              }, args)));
            }

            return null;
          });
        }
      });
      return [React.createElement(Tabs, {
        key: tabsCounter++
      }, children)];
    }
  };
};